module.exports = __webpack_public_path__ + "static/img/2.16e038c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Proteccion-digital-Empresas/2.png
// module id = mtyT
// module chunks = 0